import React from "react";

const ProtectedRoute = ({ role, children, path }) => {
  return children;
};

export default ProtectedRoute;
